import { temasDoApp } from './rua';
import { type Cores, espaco, raio, tipografia } from './tokens';

// Gera as variáveis CSS do web a partir dos MESMOS tokens dos apps nativos.
// Nome: --cor-texto, --cor-tom-sucesso-fundo, --espaco-4, --raio-md, --fonte-md...

function kebab(texto: string): string {
  return texto.replace(/[A-Z]/g, (l) => `-${l.toLowerCase()}`);
}

export function variaveisDeCor(cores: Cores): Record<string, string> {
  const vars: Record<string, string> = {};
  for (const [nome, valor] of Object.entries(cores)) {
    if (typeof valor === 'string') vars[`--cor-${kebab(nome)}`] = valor;
    // Grupos (vidro, mapa): --cor-vidro-fundo, --cor-mapa-rua...
    else if (nome !== 'tons')
      for (const [parte, cor] of Object.entries(valor as Record<string, string>))
        vars[`--cor-${kebab(nome)}-${kebab(parte)}`] = cor;
  }
  for (const [tom, cor] of Object.entries(cores.tons)) {
    vars[`--cor-tom-${tom}-fundo`] = cor.fundo;
    vars[`--cor-tom-${tom}-texto`] = cor.texto;
    vars[`--cor-tom-${tom}-solido`] = cor.solido;
  }
  return vars;
}

export function variaveisFixas(): Record<string, string> {
  const vars: Record<string, string> = {
    // Inter no painel, como nos apps (o logo é contorno e não depende de fonte).
    '--fonte-familia': `Inter, ${tipografia.familia}`,
    '--fonte-mono': tipografia.familiaMono,
  };
  for (const [k, v] of Object.entries(espaco)) vars[`--espaco-${k}`] = `${v}px`;
  for (const [k, v] of Object.entries(raio)) vars[`--raio-${kebab(k)}`] = `${v}px`;
  for (const [k, v] of Object.entries(tipografia.tamanho)) vars[`--fonte-${k}`] = `${v}px`;
  for (const [k, v] of Object.entries(tipografia.peso)) vars[`--peso-${k}`] = v;
  return vars;
}

function bloco(seletor: string, vars: Record<string, string>): string {
  const linhas = Object.entries(vars).map(([k, v]) => `  ${k}: ${v};`);
  return `${seletor} {\n${linhas.join('\n')}\n}`;
}

/**
 * CSS completo do tema (direção Rua, a mesma dos apps): claro por padrão, escuro pela preferência do sistema,
 * e `data-tema` no <html> para forçar um dos dois.
 */
export function cssDoTema(): string {
  return [
    bloco(':root', {
      ...variaveisFixas(),
      ...variaveisDeCor(temasDoApp.claro),
      'color-scheme': 'light',
    }),
    `@media (prefers-color-scheme: dark) {\n${bloco(':root:not([data-tema="claro"])', {
      ...variaveisDeCor(temasDoApp.escuro),
      'color-scheme': 'dark',
    })}\n}`,
    bloco(':root[data-tema="escuro"]', {
      ...variaveisDeCor(temasDoApp.escuro),
      'color-scheme': 'dark',
    }),
  ].join('\n\n');
}
